import { render, staticRenderFns } from "./VeJwChengjiList.vue?vue&type=template&id=bce8afa2&scoped=true"
import script from "./VeJwChengjiList.vue?vue&type=script&lang=js"
export * from "./VeJwChengjiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce8afa2",
  null
  
)

export default component.exports